import React from "react";
/* asset imports */
import proteinsCart from "../assets/images/proteins/proteins-cart.png";

const ProteinsCart = ({ handleCartClick }) => {
  return (
    <div className="proteins-cart" onClick={() => handleCartClick(4)}>
      <img src={proteinsCart} alt="" />
    </div>
  );
};

export default ProteinsCart;
